import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { MovimientoPagoService } from 'src/app/services/movimiento-pago.service';
import { PagoService } from 'src/app/services/pago.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-modal-add-pago',
  templateUrl: './modal-add-pago.component.html',
  styleUrls: ['./modal-add-pago.component.scss']
})
export class ModalAddPagoComponent implements OnInit {

  @ViewChild('seleccionarPago', { static: true }) modalSeleccionarPago: ModalDirective;

  // Outputs
  @Output() onSelect: EventEmitter<any> = new EventEmitter<any>();
  @Output() onNotFound: EventEmitter<any> = new EventEmitter<any>();

  // Form
  formData: FormGroup

  // Data &  Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  lastCodigo: number = -1
  cliente_proveedor_rut: number = null
  listaPagos: Array<any> = null
  busquedaIniciada: boolean = false
  paginationContext: PaginationContext = new PaginationContext()
  loading: boolean = false
  loaded: boolean = false

  // Utils
  private log: any
  private readonly motivoReversoPorDefecto =
    'Pertenece a un recorrido cerrado y liquidado.'

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    // private movimientoPagoService: MovimientoPagoService,
    private pagoService: PagoService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService
  ) {
    this.log = this.clog.log('MODAL-SELECCIONAR-PAGO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())
    this.paginationContext.RecordsByPage = 10
    this.createForm()
  }

  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()

    this.formData = this.fb.group({
      nroPago: [null, []], // Validators.required
      fechaDesde: [initDate, []],
      fechaHasta: [new Date(), []]
    });
  }

  buscar(searchFromStart: boolean) {
    this.busquedaIniciada = false
    if (searchFromStart)
      this.paginationContext.CurrentPage = 1
    // this.formValidatorsService.validateAllFormFields(this.formData)
    // if (!this.formData.valid)
    //   return

    const nroPago = this.formData.get('nroPago').value
    const inputParams = this.createInputParams(Number(nroPago ? nroPago : 0))

    this.pagoService.obtenerPagosRealizadosPorFecha(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.busquedaIniciada = true
      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      this.listaPagos = registros
      this.log(this.listaPagos)
    })
  }

  onPageChange(context: PaginationContext) {
    this.paginationContext.CurrentPage = context.RequestedPage
    this.buscar(false)
  }

  createInputParams(pago_codigo: number) {
    return {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        cliente_proveedor_rut: this.cliente_proveedor_rut,
        codigo: pago_codigo,
        fecha_desde: this.formData.get('fechaDesde').value,
        fecha_hasta: this.formData.get('fechaHasta').value
      },
      paginaActual: this.paginationContext.CurrentPage,
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage
    }
  }

  show(cliente_proveedor_rut) {
    this.cliente_proveedor_rut = cliente_proveedor_rut
    this.resetForm()
    this.modalSeleccionarPago.show()
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth()
    this.formData.get('fechaDesde').setValue(initDate)
    this.formData.get('fechaHasta').setValue(new Date())
  }

  hide() {
    this.modalSeleccionarPago.hide()
  }

  resetForm() {
    this.busquedaIniciada = false
    this.lastCodigo = -1
    this.formData.reset()
    this.formData.markAsPristine()
    this.formData.markAsUntouched()
    this.listaPagos = null
  }

  getMotivoReversoTooltip(pago: any): string {
    if (!pago || pago.puede_reversar !== false) {
      return null
    }
    const raw = pago.motivo_bloqueo_reverso || this.motivoReversoPorDefecto
    const prefijo = 'No se puede reversar el pago: '
    return raw.startsWith(prefijo) ? raw.substring(prefijo.length) : raw
  }

  private esReversoBloqueado(pago: any): boolean {
    return pago != null && pago.puede_reversar === false
  }

  onSeleccionarPago(pago) {
    this.log('onSeleccionarPago', pago)
    if (this.esReversoBloqueado(pago)) {
      return
    }
    this.lastCodigo = pago.codigo
    this.onSelect.emit(pago)
    this.hide()
  }

  // Método para ser consumido desde fuera del componente
  searchByCodigo(cliente_proveedor_rut, codigo: number) {
    this.cliente_proveedor_rut = cliente_proveedor_rut
    if (this.lastCodigo !== codigo) {
      this.lastCodigo = codigo
      // return
      const inputParams = this.createInputParams(codigo)
      inputParams.paginaActual = 1
      this.pagoService.obtenerPagosRealizados(inputParams, ({ respuesta }) => {
        if (!respuesta)
          return
        const { registros } = respuesta
        if (registros.length === 1) {
          if (this.esReversoBloqueado(registros[0])) {
            this.lastCodigo = -1
            return
          }
          this.onSeleccionarPago(registros[0])
        } else {
          this.onNotFound.emit()
        }
      })
    }
  }

}
